import { ReportAccessType } from "models/Reporting/ReportAccessControls";
import { UserForSharing } from "services/UserService";

export type UserWithFullName = UserForSharing & {
    fullName: string;
};

export const permissionOptions = [
    { value: ReportAccessType.Owner, label: "Owner" },
    { value: ReportAccessType.Edit, label: "Can Edit" },
    { value: ReportAccessType.View, label: "Can View" },
];